var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.label
        ? _c(
            "label",
            { staticClass: "data-label", class: { regular: _vm.regularLabel } },
            [_vm._v(" " + _vm._s(_vm.label) + " ")]
          )
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "custom-datetime-picker-container",
          class: [_vm.classContainer, _vm.error ? "invalidated" : ""]
        },
        [
          _c("i", { class: _vm.getCalendarIcon }),
          _c(
            "span",
            [
              _c(
                "datepicker",
                {
                  ref: "datePicker",
                  class: "custom-date",
                  attrs: {
                    id: _vm.id,
                    "bootstrap-styling": true,
                    "calendar-class": {
                      "custom-datetime-picker": true,
                      right: _vm.right
                    },
                    "clear-button": _vm.isClearEnabled,
                    "clear-button-icon": "fa fa-times prevent-close-dialog",
                    disabled: _vm.isDisabled,
                    "disabled-dates": _vm.disabledDates,
                    format: _vm.format,
                    "full-month-name": true,
                    language: _vm.es,
                    "monday-first": true,
                    placeholder: _vm.placeholder,
                    required: _vm.required,
                    "use-utc": _vm.useUtc,
                    value: _vm.formattedValue
                  },
                  on: {
                    cleared: _vm.cleared,
                    input: _vm.updateValue,
                    keypress: function($event) {
                      return _vm.$emit("keypress", $event)
                    },
                    selected: _vm.onSelectedDate
                  }
                },
                [
                  [
                    _c("input", {
                      attrs: { required: _vm.required },
                      domProps: { value: _vm.value },
                      on: {
                        input: function($event) {
                          return _vm.$emit("input", _vm.value)
                        },
                        keypress: function($event) {
                          return _vm.$emit("keypress", $event)
                        }
                      }
                    })
                  ]
                ],
                2
              )
            ],
            1
          )
        ]
      ),
      _vm.error
        ? _c("Error", {
            attrs: { message: _vm.customErrorMsg, variant: "no-border" }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }